import get from "lodash/get";
import React, { useState } from "react";
import { getStoryElementByType, getStoryElementsBySubType } from "../../../utils";
import { FaqItem } from "./FaqItem";
import "./faq-section.m.css";

export const FaqSection = ({ card }) => {
  const title = get(getStoryElementByType(card, "title"), ["text"], "");
  const qandElements = getStoryElementsBySubType(card, "text", "q-and-a");
  const [expandedId, setExpandedId] = useState(0);
  const [showMore, setShowMore] = useState(false);

  const handleToggle = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const id = get(card, ["metadata", "attributes", "menuname", "0"], "");

  return (
    <section styleName="faq-section" aria-label="Frequently Asked Questions" id={`${id.toLowerCase()}`}>
      <div styleName="faq-content">
        <div styleName="faq-items">
          <div styleName="faq-title">
            <div styleName="faq-heading" dangerouslySetInnerHTML={{ __html: title }} />
            {qandElements.map((element, index) => (
              <FaqItem
                key={index}
                id={element?.["id"]}
                title={get(element, ["metadata", "question"], "")}
                content={get(element, ["metadata", "answer"], "")}
                isExpanded={expandedId === index}
                setExpandedId={setExpandedId}
                onToggle={() => handleToggle(index)}
              />
            ))}
          </div>
          {/* <button styleName="view-more-button" onClick={() => setShowMore(!showMore)} aria-expanded={showMore}>
            <span styleName="view-more-background">{showMore ? "View Less" : "View More"}</span>
          </button> */}
        </div>
      </div>
    </section>
  );
};
